import Home from "./pages/home/Home";
// import Login from "./pages/login/Login";
// import Register from "./pages/register/Register";
// import Profile from "./pages/profile/Profile";
function App() {
  return (
    <div>
      <Home />
    </div>
  );
}

export default App;
